import { useRef, useState } from 'react';

const PROJECTS = [
  {
    n: '01',
    title: 'Axyonex',
    kicker: 'Algorithmic Trading Platform',
    image: '/portfolio/axyonex/screenshot-1.png',
    stack: ['Rust', 'React', 'WebSocket', 'PostgreSQL'],
    headline: 'Sub-millisecond order routing across 3 brokers.',
    body: 'Professional-grade multi-broker trading platform. Rust execution engine with real-time WebSocket feeds, strategy backtesting, and automated position management across Kite, Fyers, and XTS APIs.',
    status: 'In Development',
    color: '#10b981',
  },
  {
    n: '02',
    title: 'iOS App Suite',
    kicker: '15 Apps Across 8 Categories',
    image: '/portfolio/ios-apps/collage.png',
    stack: ['Swift', 'SwiftUI', 'StoreKit 2', 'CloudKit'],
    headline: '15 apps built, 8 categories, each with a Pro tier.',
    body: 'Production app portfolio spanning fitness, finance, sports analytics, and productivity. Native SwiftUI, StoreKit 2 subscriptions, CloudKit sync. PackPal, TapLedger, Hydrate Daily, Prismatica, and more.',
    status: 'Launching Q2 2026',
    color: '#f472d0',
  },
  {
    n: '03',
    title: 'Fortress',
    kicker: 'Network Security Platform',
    image: '/portfolio/fortress/screenshot-1.png',
    stack: ['Python', 'FastAPI', 'scapy', 'nmap', 'React'],
    headline: 'Real-time threat detection across network interfaces.',
    body: 'Enterprise security monitoring with real-time packet inspection, automated threat detection, vulnerability scanning, and compliance reporting. Built for organizations that take security seriously.',
    status: 'Beta',
    color: '#a78bfa',
  },
  {
    n: '04',
    title: 'Life-OS',
    kicker: 'Health & Life Management Platform',
    image: '/portfolio/life-os/screenshot-1.png',
    stack: ['Swift', 'React', 'Node.js', 'CloudKit'],
    headline: 'Unified health tracking across iOS app + web dashboard.',
    body: 'Comprehensive life and health management system with mobile app, web dashboard, and backend server. Tracks health metrics, daily routines, and personal goals in one unified platform.',
    status: 'Production',
    color: '#34d399',
  },
  {
    n: '05',
    title: 'Payments',
    kicker: 'Payment Tracking Application',
    image: '/portfolio/payments/screenshot-1.png',
    stack: ['Vite', 'Tailwind CSS', 'Node.js', 'Docker'],
    headline: 'Docker-containerized architecture with real-time tracking.',
    body: 'Modern payment tracking and management application with a clean, responsive interface. Docker-containerized backend for reliable deployment with a fast Vite-powered frontend.',
    status: 'Production',
    color: '#f59e0b',
  },
];

const TiltCard = ({ children, className }) => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    const rotY = (px - 0.5) * 8;
    const rotX = -(py - 0.5) * 8;
    el.style.transform = `perspective(1200px) rotateX(${rotX}deg) rotateY(${rotY}deg)`;
    el.style.setProperty('--mx', `${px * 100}%`);
    el.style.setProperty('--my', `${py * 100}%`);
  };
  const onLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = 'perspective(1200px) rotateX(0) rotateY(0)';
  };
  return (
    <div ref={ref} className={className} onMouseMove={onMove} onMouseLeave={onLeave}>
      {children}
    </div>
  );
};

const Work = () => {
  const [active, setActive] = useState(0);
  const p = PROJECTS[active];
  return (
    <section className="r-section work" id="work">
      <div className="r-wrap">
        <div className="r-tag r-reveal">Selected work</div>
        <h2 className="r-head r-reveal">
          Production-grade.<br /><span className="r-gtxt">Shipped — not pitched.</span>
        </h2>

        <div className="work-stage">
          <div className="work-rail">
            {PROJECTS.map((proj, i) => (
              <button
                key={proj.n}
                type="button"
                className={`wr-item ${i === active ? 'is-on' : ''}`}
                onClick={() => setActive(i)}
              >
                <span className="wr-num">{proj.n}</span>
                <span className="wr-title">{proj.title}</span>
                <span className="wr-kick">{proj.kicker}</span>
                {i === active && <span className="wr-bar" style={{ background: proj.color }} />}
              </button>
            ))}
          </div>

          <TiltCard className="work-card r-panel">
            <div className="work-image" style={{ backgroundImage: `url(${p.image})` }}>
              <div
                className="work-image-wash"
                style={{ background: `linear-gradient(180deg, transparent 20%, ${p.color}33 60%, rgba(8,8,12,0.95) 100%)` }}
              />
              <div className="work-image-grain" />
            </div>

            <div className="work-card-body">
              <div className="wc-row">
                <span className="wc-status" style={{ borderColor: `${p.color}55`, color: p.color }}>
                  <span className="wc-dot" style={{ background: p.color }} />
                  {p.status}
                </span>
                <span className="wc-num">{p.n} / {String(PROJECTS.length).padStart(2, '0')}</span>
              </div>
              <h3 className="wc-title">{p.title}</h3>
              <p className="wc-headline">{p.headline}</p>
              <p className="wc-body">{p.body}</p>
              <div className="wc-stack">
                {p.stack.map((s) => <span key={s}>{s}</span>)}
              </div>
            </div>

            <div className="work-card-light" />
          </TiltCard>
        </div>
      </div>
    </section>
  );
};

export default Work;
